// import { machine } from '../../create-order-machine'
import { buildStateNode } from '../../build-state-node'
import { clearProducts, clearProductsForEditWro, saveProducts, setHasBeenEditedFlag } from './actions'

const STEP_NAME = 'selectProducts'
const EDIT_NAME = STEP_NAME + '.' + 'valid'

const PRODUCT_ADDED = { productsAdded: { actions: [setHasBeenEditedFlag(true)] } }
const INVALID = PRODUCT_ADDED
const EDITED = { valid: { actions: [setHasBeenEditedFlag(true)] } }

const stateNodeGenerator = buildStateNode({
  initial: 'empty',
  states: {
    empty: {
      onEntry: [clearProducts, setHasBeenEditedFlag(true)],
      on: {
        PRODUCT_ADDED
      }
    },
    emptyEdit: {
      onEntry: [clearProductsForEditWro],
      on: {
        PRODUCT_ADDED
      }
    },
    productsAdded: {
      on: {
        VALIDATED_AND_CHECKED: 'valid',
        ALL_PRODUCTS_REMOVED: 'empty',
        CLEAR: 'empty',
        EDIT_CLEAR: 'emptyEdit'
      }
    },
    valid: {
      states: {
        saving: {
          on: {
            SAVE_FAIL: 'error'
          }
        },
        error: {}
      },
      on: {
        ALL_PRODUCTS_REMOVED: 'empty',
        PRODUCT_ADDED,
        INVALID, // Do nothing to the machine's state...
        EDITED,
        SAVE: {
          '.saving': {
            actions: [saveProducts(), setHasBeenEditedFlag(false)]
          }
        },
        CLEAR: 'empty',
        EDIT_CLEAR: 'emptyEdit'
      }
    }
  }
})

export const selectProducts = {
  name: STEP_NAME,
  editState: EDIT_NAME,
  stateNodeGenerator
}
